import React from 'react';

// interface
import { IProductModuleProps, ILinkProps } from '../../../interfaces/interfaces';

// module, source
import Header from '../../elements/Header/Header';
import Link from '../../elements/Link/Link';
import TileWrapper from '../../elements/TileWrapper/TileWrapper';

function ProductModule(props: IProductModuleProps & ILinkProps): JSX.Element {
  const { headline, creditId, textContent, linkHref, linkText, tileId, isEditable, hideMenu } = props;

  return (
    <div className="tile-body">
      {headline ? <Header headline={headline} tileId={tileId} hideMenu={hideMenu} isEditable={isEditable} /> : ''}

      <TileWrapper className="tile-padding" clickable>
        <p className="hl-2 bold font-color-blue">{creditId}</p>
        {/* eslint-disable-next-line react/no-danger */}
        <p className="tx_1" dangerouslySetInnerHTML={{ __html: textContent }} />
        <Link
          linkHref={linkHref}
          linkText={linkText}
          linkClass="tile-link link ic-arrowRight"
          linkTextClass="link-text"
        />
      </TileWrapper>
    </div>
  );
}
export default ProductModule;
